import { type Pagination, type ProgramMember, createProgramMember } from 'models';
import { useInfiniteQuery } from 'query';
import { getProgramsUsers } from '../services';
import type { ProgramsUsersListFilter } from '../types';
import { getProgramUsersInfiniteQueryKey } from './keys';

type P = {
  filter: ProgramsUsersListFilter;
  pagination: Omit<Pagination, 'position'>;
};

type ProgramMembersPage = {
  joinedCount: number;
  pendingCount: number;
  users: ProgramMember[];
};

export const useProgramMembersInfiniteQuery = ({ filter, pagination }: P) =>
  useInfiniteQuery<ProgramMembersPage, string | undefined>({
    async queryFn({ pageParam: cursor }) {
      const response = await getProgramsUsers({
        config: {
          params: { cursor, limit: pagination.pageSize, search: filter.search, sort: filter.sort },
        },
        routeParams: { id: filter.programId },
      });

      return {
        joinedCount: response.data.joined_count,
        pendingCount: response.data.pending_count,
        users: response.data.users.map((user) => createProgramMember(user)),
      };
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) =>
      lastPage.users.length < pagination.pageSize ? undefined : lastPage.users.at(-1)?.id,
    queryKey: getProgramUsersInfiniteQueryKey({ filter, pagination }),
    refetchOnMount: 'always',
  });
